import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const PublicRoute = ({ component: Component, ...rest }) => {
    const token = localStorage.getItem('token');
    return (
        <Route
            {...rest}
            render={(routeProps) => (token ? <Redirect to="/bookings" /> : <Component {...routeProps} />)}
        />
    );
};

export default PublicRoute;
